/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * Position of a weekday within a month, used by FacilityFlow.Core.Modules.Planning.Entities.TaskScheduleRuleType.Monthly
(e.g. "first Tuesday", "last Friday").
 */
export type FacilityFlowCoreModulesPlanningEntitiesWeekdayOrdinal = typeof FacilityFlowCoreModulesPlanningEntitiesWeekdayOrdinal[keyof typeof FacilityFlowCoreModulesPlanningEntitiesWeekdayOrdinal];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesPlanningEntitiesWeekdayOrdinal = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;
